import spreeLike from '@/theme/spreeLike';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import React from 'react';

export default function SpreeThemeProvider({ children }: { children: React.ReactNode }) {
  // Merge existing app theme with spree-like overrides
  // If nested under another ThemeProvider, read and extend it
  // Fallback createTheme if hook fails (outside provider)
  try {
    const base = useTheme();
    const merged = React.useMemo(() => createTheme(base, spreeLike), [base]);
    return <ThemeProvider theme={merged}>{children}</ThemeProvider>;
  } catch {
    const merged = React.useMemo(() => createTheme(spreeLike), []);
    return <ThemeProvider theme={merged}>{children}</ThemeProvider>;
  }
}
